import React, { Component, Ref } from "react";
import { _ReactPixi, withPixiApp } from "@inlet/react-pixi";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import withFreeGameConfiguration from "../../core/components/freegame/configuration/withFreeGameConfiguration";
import UIManager from "../../core/components/ui/UiBuilder";
import { actions as layoutsActions } from "../../core/reducers/layoutsStateReducer";
import PIXI from "pixi.js";
import { isMobile } from "react-device-detect";
import { CURRENCY, TIMER } from "../../core/utills";
import { configGame } from "../../data/config";
import { actions as soundActions } from "../../core/reducers/soundReducer";
import { actions as asyncActions } from "../../core/reducers/asyncServerResponseReducer";
import { actions as winpresentationAction } from "../../core/reducers/winPresentationReducer";
import { actions as reelgridAction } from "../../core/reducers/reelgridStateReducer";
import { actions as basegameActions, actions as basegameAction } from "../../core/reducers/baseGameReducer";
import { actions as freegameActions, actions as freegameAction } from "../../core/reducers/freeGameReducer";
import { actions as multiplierActions } from "../../gamereducer/multiplierReducer";
import { actions as behaviourAction, actionTypes } from "../../gamereducer/behaviourReducer";
import { actions as buttonActions } from "../../core/reducers/buttonPanelReducer";
import { actions as horizontalSymbolActions } from "../../gamereducer/horizontalSymbolReducer";
import { actions as lockedReelActions } from "../../gamereducer/lockedReelReducer";
import { actions as aplicationActions } from "../../core/reducers/applicationStateReducer";
import { actions as gridsActions } from '../../core/reducers/gridStateReducer';
import { actions as behaviorActions } from "../../gamereducer/behaviourReducer";
import { actions as giantWildActions } from "../../gamereducer/giantWildReducer";
interface IProps {
    [x: string]: any;
}

interface IStore {
    [x: string]: any;
}

interface IStateToProps {

    layoutMode: string,
    // winAmount: number,
    inFreeGame: any,
    soundIsPlaying: any,
    freegameSpinCountRemaining: any,
    freegameSpinCountWin: any,
    freegameSpinCount: any,
    displayReelGridSymbolCount: any,
    spinStopID: any,
    allSpinComplete: any,
    featureJustReTriggered: any,
    callFlowManager: any,
    lockedReelArr: any,
    featureJustFinished: any,
    totalWinAmount: any,
    totalCreditWinAmount: any,
    transitionBalance: any,
    balance: any,
    betList: any;
    currentBetIndex: any;
    multiplierActive: any;
    storeMultiplierCurrentValue: any;
    selectedCoin: any;
    coinList: any;
    spinStart: any;
    blastStart: any;
    currentCascadeCount: any;
    winAmount: any;
    InTurboMode: any;
    startGiantWild: any;
    bodyBuilderSelected: any;
    startRandomWild: any;

}

interface IDispatchToProps {
}

interface IState {
    [x: string]: any;
}

class GameFreeGameSpecialLayer extends Component<IProps, IState> {
    protected app: PIXI.Application;
    protected gameFreeGameBaseLayerContainer: _ReactPixi.IContainer | Ref<any>;
    protected ui_mode: string;
    protected displayUI: any;
    protected logoAnimIntervalTime: number;
    protected freeGameFrameBorder: any;
    protected freeGameFramesInsidePortionImage: any;
    protected multiwaysTextImage: any;
    protected logoForMobile: any;
    protected logoForDesktop: any;
    protected originalScalingOfObject: number = 1;
    protected frameBorderScalingX: number = 0.88;
    protected frameBorderScalingY: number = 0.869;
    protected frameInsideScalingX: number = 0.85;
    protected frameInsideScalingY: number = 0.88;
    protected multiwaysTextPortraitScalingX: number = 0.7;
    protected multiwaysTextPortraitScalingY: number = 0.8;
    private minFullHDWidth: number = 1024;
    private HDReadyWidth: number = 1280;
    private fullHDWidth: number = 1920;
    private minFullHDPxRatio: number = 2;
    private canvasBgImagePage: string = "";
    protected megaWaysTextValue: number = 1;
    // protected freeGameCounter: number = 0;
    protected storeWinAmount: number = 0;
    protected delayTimerOfMultiplierWithAnticipation: number = 7500;
    protected delayTimerOfMultiplierWithOutAnticipation: number = 2200;
    protected alphaOfMultiways: number = 0.1;
    protected reelGridSymbolsArray: any = [];

    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.state = {
            uiElements: [],
            lang: "en",
            isSpinning: false,
        }
        this.gameFreeGameBaseLayerContainer = React.createRef();
        if (isMobile) {
            this.ui_mode = "mobile";
        } else {
            this.ui_mode = "desktop";
        }
        this.logoAnimIntervalTime = 11050;

        this.displayUI = this.props.child.filter(this.checkUiMode.bind(this));
        this.chooseAssets();
    }


    //while first rendering, this method will check the mode first
    checkUiMode(uimodeobj: any) {
        if (uimodeobj.uimode === undefined) {
            uimodeobj.uimode = "both";
        }
        if (uimodeobj.uimode === "both" || uimodeobj.uimode === this.ui_mode) {
            return uimodeobj;
        }
    }

    //when layout changes, this method will be called
    layoutChange(currentLayout: string) {
        this.displayUI.map((data: any) => {
            if (data.layout === true) {
                this.props.setApplicationLayoutObject(data.name);
            }
        }
        )
        this.strokeButtonRotate();
        let timer = TIMER.TimerManager.createTimer(50);
        timer.on('end', (e: any) => {
            e.remove();
            this.changeButton();

        });
        timer.start();
        let timer1 = TIMER.TimerManager.createTimer(51);
        timer1.on('end', (e: any) => {
            e.remove();
            this.characterLayoutChange();
        })
        timer1.start();

    }
    characterLayoutChange() {

        if (this.props.bodyBuilderSelected) {
            UIManager.getRef("fg_bodyBuilderCharecterIdle_mobile") && (UIManager.getRef("fg_bodyBuilderCharecterIdle_mobile").visible = true);
            UIManager.getRef("fg_skeletonCharacterIdle_mobile") && (UIManager.getRef("fg_skeletonCharacterIdle_mobile").visible = false);
        } else {
            UIManager.getRef("fg_bodyBuilderCharecterIdle_mobile") && (UIManager.getRef("fg_bodyBuilderCharecterIdle_mobile").visible = false);
            UIManager.getRef("fg_skeletonCharacterIdle_mobile") && (UIManager.getRef("fg_skeletonCharacterIdle_mobile").visible = true);
        }
    }

    onOrientationChange() {
        let reelGrid = UIManager.getRef("reelgridLayer");
        if (isMobile && window.innerHeight > window.innerWidth) {

            UIManager.getRef("total_win_text_freegame_mobile") && UIManager.getRef("total_win_text_freegame_mobile").scale.set(0.92);
            UIManager.getRef("game_logoContainer_mobile") && UIManager.getRef("game_logoContainer_mobile").scale.set(0.37);
            UIManager.getRef("fg_skeletonCharacterIdle_mobile") && UIManager.getRef("fg_skeletonCharacterIdle_mobile").scale.set(0.82);
            UIManager.getRef("fg_bodyBuilderCharecterIdle_mobile") && UIManager.getRef("fg_bodyBuilderCharecterIdle_mobile").scale.set(0.92);
            UIManager.getRef("total_win_meter_fg_mobile") && UIManager.getRef("total_win_meter_fg_mobile").scale.set(0.92);
            reelGrid && reelGrid.scale.set(configGame.REEL_GRID_SCALE_IN_PORTRAIT);
            reelGrid && reelGrid.position.set(configGame.REEL_GRID_X_IN_PORTRAIT, configGame.REEL_GRID_Y_IN_PORTRAIT);
        } else {

            UIManager.getRef("game_logoContainer_mobile") && UIManager.getRef("game_logoContainer_mobile").scale.set(0.55);
            UIManager.getRef("fg_skeletonCharacterIdle_mobile") && UIManager.getRef("fg_skeletonCharacterIdle_mobile").scale.set(1);
            UIManager.getRef("fg_bodyBuilderCharecterIdle_mobile") && UIManager.getRef("fg_bodyBuilderCharecterIdle_mobile").scale.set(1);
            UIManager.getRef("total_win_meter_fg_mobile") && UIManager.getRef("total_win_meter_fg_mobile").scale.set(1);
            UIManager.getRef("total_win_text_freegame_mobile") && UIManager.getRef("total_win_text_freegame_mobile").scale.set(1);
            reelGrid && reelGrid.scale.set(configGame.REEL_GRID_SCALE);
            reelGrid && reelGrid.position.set(configGame.REEL_GRID_X, configGame.REEL_GRID_Y);
        }
    }

    //scaling for landscape mode
    landscapeScaling() {
        //  this.freeGameFrameBorder && (this.freeGameFrameBorder.scale.set(this.originalScalingOfObject));
        this.freeGameFramesInsidePortionImage && (this.freeGameFramesInsidePortionImage.scale.set(this.originalScalingOfObject));
        this.multiwaysTextImage && (this.multiwaysTextImage.scale.set(this.originalScalingOfObject));
    }

    //scaling for portrait mode
    portraitScaling() {
        // this.freeGameFrameBorder && (this.freeGameFrameBorder.scale.x = this.frameBorderScalingX);
        // this.freeGameFrameBorder && (this.freeGameFrameBorder.scale.y = this.frameBorderScalingY);
        this.freeGameFramesInsidePortionImage && (this.freeGameFramesInsidePortionImage.scale.x = this.frameInsideScalingX);
        this.freeGameFramesInsidePortionImage && (this.freeGameFramesInsidePortionImage.scale.y = this.frameInsideScalingY);
        this.multiwaysTextImage && (this.multiwaysTextImage.scale.x = this.multiwaysTextPortraitScalingX);
        this.multiwaysTextImage && (this.multiwaysTextImage.scale.y = this.multiwaysTextPortraitScalingY);
    }

    symbolsCountRearrangeCount(nextProps: any) {
        for (let i = 0; i < nextProps.displayReelGridSymbolCount.length; i++) {
            let data;
            if (i == 0 || i == nextProps.displayReelGridSymbolCount.length - 1) {
                data = nextProps.displayReelGridSymbolCount[i];
            } else if (i > 0) {
                data = nextProps.displayReelGridSymbolCount[i] + 1;
            }

            this.reelGridSymbolsArray.push(data);
        }
    }
    falseInteractivityOfCharacButton() {
        let skeletonBtn, bodyBuilderBtn;
        skeletonBtn = UIManager.getRef("fg_skeletonCharacterBtn_" + this.ui_mode);
        bodyBuilderBtn = UIManager.getRef("fg_bodyBuilderCharacterBtn_" + this.ui_mode);

        if (this.props.bodyBuilderSelected) {
            skeletonBtn.interactive = false;
            skeletonBtn.buttonMode = false;
        }
        else {
            bodyBuilderBtn.interactive = false;
            bodyBuilderBtn.buttonMode = false;
        }



    }

    trueInteractivityOfCharacButton() {
        let skeletonBtn, bodyBuilderBtn;
        skeletonBtn = UIManager.getRef("fg_skeletonCharacterBtn_" + this.ui_mode);
        bodyBuilderBtn = UIManager.getRef("fg_bodyBuilderCharacterBtn_" + this.ui_mode);
        if (this.props.bodyBuilderSelected) {
            skeletonBtn.interactive = true;
            skeletonBtn.buttonMode = true;
        }
        else {
            bodyBuilderBtn.interactive = true;
            bodyBuilderBtn.buttonMode = true;
        }

    }
    correctCurrencyCodeXAF(amount: string) {
        if ((window as any).GAME_INFO.currency == "XAF") {
            return amount.replace('F', 'FCFA');
        }
        if ((window as any).GAME_INFO.currency == "XOF") {
            return amount.replace('F', 'XOF');
        }
        return amount;
    }
    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (nextProps.layoutMode !== this.props.layoutMode
            || nextProps.inFreeGame !== this.props.inFreeGame || nextProps.soundIsPlaying != this.props.soundIsPlaying
            || nextProps.freegameSpinCountRemaining != this.props.freegameSpinCountRemaining
            || nextProps.freegameSpinCount != this.props.freegameSpinCount
            || nextProps.displayReelGridSymbolCount != this.props.displayReelGridSymbolCount
            || nextProps.spinStopID != this.props.spinStopID
            || nextProps.featureJustFinished != this.props.featureJustFinished
            || nextProps.callFlowManager !== this.props.callFlowManager
            || nextProps.spinStart !== this.props.spinStart
            || nextProps.lockedReelArr !== this.props.lockedReelArr
            || nextProps.blastStart !== this.props.blastStart
            || nextProps.allSpinComplete !== this.props.allSpinComplete
            || nextProps.startGiantWild != this.props.startGiantWild
            || nextProps.startRandomWild != this.props.startRandomWild
        ) {


            if ((nextProps.startGiantWild && nextProps.startGiantWild != this.props.startGiantWild) || (nextProps.startRandomWild && nextProps.startRandomWild != this.props.startRandomWild)) {

                this.falseInteractivityOfCharacButton();
            }
            if (nextProps.callFlowManager && nextProps.callFlowManager != this.props.callFlowManager) {

                this.trueInteractivityOfCharacButton();
            }
            if (nextProps.layoutMode !== this.props.layoutMode) {
                this.layoutChange(nextProps.layoutMode);
                this.onOrientationChange();

                if (isMobile) {
                    if (window.innerWidth < window.innerHeight) {
                        this.portraitScaling();
                    } else {
                        this.landscapeScaling();
                    }
                }
            }

            if (nextProps.allSpinComplete) {
                if (nextProps.lockedReelArr.length) {
                    this.props.setShowLockedReel();
                }
            }


            if (nextProps.featureJustFinished) {
                this.props.setMultiplierForBuyFeature(false);
                if (nextProps.allSpinComplete) {


                }
            }
            if (nextProps.spinStart && nextProps.spinStart != this.props.spinStart) {
                if (!nextProps.InTurboMode || !this.props.InTurboMode) {
                }
                else {
                    UIManager.getRef("FG_multiwaysText_desktop") && (UIManager.getRef("FG_multiwaysText_desktop").alpha = 0);
                    UIManager.getRef("FG_multiwaysText_mobile") && (UIManager.getRef("FG_multiwaysText_mobile").alpha = 0);
                    UIManager.getRef("FG_textMultiWays_Image_mobile") && (UIManager.getRef("FG_textMultiWays_Image_mobile").alpha = 0);
                }
            }


            if (nextProps.blastStart && nextProps.blastStart !== this.props.blastStart) {
                let time;
                if (this.props.playAnticipation) {
                    time = this.delayTimerOfMultiplierWithAnticipation;
                }
                else {
                    time = this.delayTimerOfMultiplierWithOutAnticipation;
                }
                let timer = TIMER.TimerManager.createTimer(time);
                timer.on('end', (e: any) => {
                    e.remove();
                    this.props.setMultiplierValue(nextProps.storeMultiplierCurrentValue);


                });
                timer.start();
                let winAmount = ((this.props.winAmount + this.storeWinAmount) / 100).toFixed(2);
                let win = CURRENCY.CurrencyManager.formatCurrencyString(winAmount, true, true, true, true);
                win = this.correctCurrencyCodeXAF(win);
                if (!isMobile) {
                    UIManager.getRef("text_TotalWin_value").visible = true;
                    UIManager.getRef("text_TotalWin_value") && (UIManager.setText("text_TotalWin_value", win));
                }

                this.storeWinAmount = nextProps.winAmount + this.storeWinAmount;
                if (nextProps.freegameSpinCountRemaining == 0) {

                    this.props.setTotalCreditWinAmount(this.storeWinAmount);
                }
            }

            if (nextProps.allSpinComplete && nextProps.allSpinComplete !== this.props.allSpinComplete) {
                if (nextProps.featureJustReTriggered) {
                    this.startTextChangingEffect(nextProps);
                }


                if (nextProps.freegameSpinCountRemaining == 0) {
                    let amount = this.storeWinAmount - nextProps.winAmount;
                    let finalAmount = this.storeWinAmount - amount;



                    this.props.setTotalCreditWinAmount(finalAmount);
                }
            }

            if (nextProps.freegameSpinCount != this.props.freegameSpinCount) {

                UIManager.getRef("text_FreeGame_value1") && (UIManager.setText("text_FreeGame_value1", nextProps.freegameSpinCount));
                UIManager.getRef("text_FreeGame_value2") && (UIManager.setText("text_FreeGame_value2", nextProps.freegameSpinCountWin));
            }

            if (nextProps.displayReelGridSymbolCount !== this.props.displayReelGridSymbolCount) {
                this.megaWaysTextValue = 1;
                this.reelGridSymbolsArray = [];
                this.symbolsCountRearrangeCount(nextProps);
            }
            if (nextProps.spinStopID > -1) {
                UIManager.getRef("FG_multiwaysText_desktop") && (UIManager.getRef("FG_multiwaysText_desktop").alpha = 1);
                UIManager.getRef("FG_multiwaysText_mobile") && (UIManager.getRef("FG_multiwaysText_mobile").alpha = 1);
                UIManager.getRef("FG_textMultiWays_Image_mobile") && (UIManager.getRef("FG_textMultiWays_Image_mobile").alpha = 1);
                this.megaWaysTextValue = this.megaWaysTextValue * this.reelGridSymbolsArray[nextProps.spinStopID];
                UIManager.getRef("FG_multiwaysText_desktop") && (UIManager.getRef("FG_multiwaysText_desktop").text = this.megaWaysTextValue);
                UIManager.getRef("FG_multiwaysText_mobile") && (UIManager.getRef("FG_multiwaysText_mobile").text = this.megaWaysTextValue);
            }

            return false;

        }

        return false;
    }

    //this function will show the effect of increasing free spins when 3 or more scatter trigger.
    startTextChangingEffect(nextProps: any) {

    }

    //this method will call after the first rendering for scaling and logo animation looping
    bindUI() {
        this.layoutChange(this.props.layoutMode);
        if (isMobile) {
            if (window.innerWidth < window.innerHeight) {
                this.portraitScaling();

            } else {
                this.landscapeScaling();
            }
            this.logoForMobile && (this.logoForMobile.gotoAndPlay(0));


        } else {
            this.logoForDesktop && (this.logoForDesktop.gotoAndPlay(0));
        }

        let timer = TIMER.TimerManager.createTimer(this.logoAnimIntervalTime);
        timer.on('repeat', () => {
            if (isMobile) {
                this.logoForMobile && (this.logoForMobile.gotoAndPlay(0));
            } else {
                this.logoForDesktop && (this.logoForDesktop.gotoAndPlay(0));
            }
        });
        timer.start(true, 20);


    }

    //this method will handle sounds on button's visibility accordingly
    /*  soundOnButtonFunctionality() {
         if (this.props.soundIsPlaying) {
             this.props.playingSound(false);
             this.props.stopAllBGMSound(true);
         }
 
     } */

    //this method will handle mute button's visibility accordingly
    soundOnButtonFunctionality() {
        if (this.props.soundIsPlaying) {
            this.props.playingSound(false);
            this.props.stopAllBGMSound(true);
            this.props.stopAllSFXSound(true);
        }

    }

    //this method will handle mute button's visibility accordingly
    soundOffButtonFunctionality() {
        this.props.soundLoadStartFunction(true);
        if (this.props.soundIsPlaying) {
            this.props.playingSound(false);
            this.props.stopAllBGMSound(true);
            this.props.stopAllSFXSound(true);
        } else {
            this.props.stopAllBGMSound(false);
            this.props.stopAllSFXSound(false);
            this.props.playingSound(true);
        }
    }
    handleEvent = (e: any) => {

        UIManager.getRef("animChangeEffect_" + this.ui_mode) && (UIManager.getRef("animChangeEffect_" + this.ui_mode).visible = false);
        let skeletonBtn, bodyBuilderBtn;
        skeletonBtn = UIManager.getRef("fg_skeletonCharacterBtn_" + this.ui_mode);
        bodyBuilderBtn = UIManager.getRef("fg_bodyBuilderCharacterBtn_" + this.ui_mode);
        if (e.name === "fg_skeletonCharacterBtn_" + this.ui_mode) {
            skeletonBtn.visible = false;
            bodyBuilderBtn.visible = true;
            this.changeCharacter("fg_skeletonCharacterIdle_" + this.ui_mode, "fg_bodyBuilderCharecterIdle_" + this.ui_mode);
            this.props.changeCharacter(false);
        }
        if (e.name === "fg_bodyBuilderCharacterBtn_" + this.ui_mode) {
            skeletonBtn.visible = true;
            bodyBuilderBtn.visible = false;
            this.changeCharacter("fg_bodyBuilderCharecterIdle_" + this.ui_mode, "fg_skeletonCharacterIdle_" + this.ui_mode);
            this.props.changeCharacter(true);

        }


        if (isMobile) {
            if (e.currentTarget) {
                if (e.currentTarget.name === "btn_soundFG") {
                    this.soundOnButtonFunctionality();
                    this.changeButton();

                }

                if (e.currentTarget && e.currentTarget.name === "btn_soundOffFG") {
                    this.soundOffButtonFunctionality();
                    this.changeButton();

                }
            }
        }


    }


    changeButton() {
        if (isMobile) {
            // it should be un comment whent sound btn placed RAJANU
            if (this.props.soundIsPlaying) {
                UIManager.getRef("btn_soundFG").visible = true;
                UIManager.getRef("btn_soundOffFG").visible = false;
            } else {

                UIManager.getRef("btn_soundFG").visible = false;
                UIManager.getRef("btn_soundOffFG").visible = true;

            }
        }
    }
    changeCharacter(currentCharacter: any, previousCharacter: any) {
        let transitionSpine = UIManager.getRef("fg_animChangeEffect_" + this.ui_mode);
        //  let btnGlowSpine = UIManager.getRef("Fg_btnGlow_desktop");


        transitionSpine && (transitionSpine.visible = true);

        UIManager.getRef("btnGlowContainerFg") && (UIManager.getRef("btnGlowContainerFg").visible = true);
        //  btnGlowSpine && btnGlowSpine.children[0].state.setAnimation(0, "fx_glow_yellow", false);


        transitionSpine && transitionSpine.children[0].state.setAnimation(0, "trans", false);
        let timer = TIMER.TimerManager.createTimer(400);
        timer.on('end', (e: any) => {
            UIManager.getRef(currentCharacter) && (UIManager.getRef(currentCharacter).visible = true);
            UIManager.getRef(previousCharacter) && (UIManager.getRef(previousCharacter).visible = false);
        })
        timer.start();
    }


    //this method will initialize object in a variable
    initializeObjectToVariable() {
        //   this.freeGameFrameBorder = UIManager.getRef("frame_FG_Image_Mob");
        this.freeGameFramesInsidePortionImage = UIManager.getRef("frameReel_FG_Image_Mob");
        this.multiwaysTextImage = UIManager.getRef("FG_textMultiWays_Image_mobile");
        this.logoForDesktop = UIManager.getRef("FG_gameLogo_Anim_desktop");
        this.logoForMobile = UIManager.getRef("FG_gameLogo_Anim_mobile");
    }



    componentDidMount() {
        this.storeWinAmount = 0;
        this.initializeObjectToVariable();
        this.bindUI();
        this.onOrientationChange();
        this.changeButton();
        if (isMobile) {
            this.props.setApplicationButtonpanelVisibility(false);
        }
        // this.props.setApplicationButtonpanelVisibility(true);
        if (this.props.freegameSpinCount !== this.props.freegameSpinCountRemaining) {
            this.props.activeMultiplier(true);
            this.props.setMultiplierValue(this.props.storeMultiplierCurrentValue);
        }
        if (isMobile) {
            UIManager.getRef("fg_bodyBuilderCharecterIdle_" + this.ui_mode) && (UIManager.getRef("fg_bodyBuilderCharecterIdle_" + this.ui_mode).visible = true);
        }
        UIManager.getRef("fg_bodyBuilderCharacterBtn_" + this.ui_mode) && (UIManager.getRef("fg_bodyBuilderCharacterBtn_" + this.ui_mode).click = (event: any) => {
            this.handleEvent(UIManager.getRef("fg_bodyBuilderCharacterBtn_" + this.ui_mode));
        })

        UIManager.getRef("fg_skeletonCharacterBtn_" + this.ui_mode) && (UIManager.getRef("fg_skeletonCharacterBtn_" + this.ui_mode).click = (event: any) => {
            this.handleEvent(UIManager.getRef("fg_skeletonCharacterBtn_" + this.ui_mode));
        })



        UIManager.getRef("fg_bodyBuilderCharacterBtn_" + this.ui_mode) && (UIManager.getRef("fg_bodyBuilderCharacterBtn_" + this.ui_mode).touchend = (event: any) => {
            this.handleEvent(UIManager.getRef("fg_bodyBuilderCharacterBtn_" + this.ui_mode));
        })

        UIManager.getRef("fg_skeletonCharacterBtn_" + this.ui_mode) && (UIManager.getRef("fg_skeletonCharacterBtn_" + this.ui_mode).touchend = (event: any) => {
            this.handleEvent(UIManager.getRef("fg_skeletonCharacterBtn_" + this.ui_mode));
        })
        this.symbolsCountRearrangeCount(this.props);
        let totalMegaWaysCount = 1;
        for (let j = 0; j < this.reelGridSymbolsArray.length; j++) {
            totalMegaWaysCount = totalMegaWaysCount * this.reelGridSymbolsArray[j];
        }
        UIManager.getRef("FG_multiwaysText_desktop") && (UIManager.getRef("FG_multiwaysText_desktop").text = totalMegaWaysCount);
        UIManager.getRef("FG_multiwaysText_mobile") && (UIManager.getRef("FG_multiwaysText_mobile").text = totalMegaWaysCount);
        let balanceInCurrency = CURRENCY.CurrencyManager.formatCurrencyString(this.props.balance / 100, true, true, true, true);
        balanceInCurrency = this.correctCurrencyCodeXAF(balanceInCurrency);

        UIManager.getRef("Mobiletext_balance_valueFG") && (UIManager.setText("Mobiletext_balance_valueFG", balanceInCurrency));
        let betInCurrency = CURRENCY.CurrencyManager.formatCurrencyString(this.props.betList[this.props.currentBetIndex] / 100, true, true, true, true);
        betInCurrency = this.correctCurrencyCodeXAF(balanceInCurrency);
        UIManager.getRef("Mobiletext_bet_valueFG") && (UIManager.setText("Mobiletext_bet_valueFG", betInCurrency));

        this.setFGCountBannerText();

        let winAmount = ((this.props.totalWinAmount + this.storeWinAmount) / 100).toFixed(2);
        let win = CURRENCY.CurrencyManager.formatCurrencyString(winAmount, true, true, true, true);
        win = this.correctCurrencyCodeXAF(win);
        if (!isMobile) {
            UIManager.getRef("text_TotalWin_value").visible = true;
            UIManager.getRef("text_TotalWin_value") && (UIManager.setText("text_TotalWin_value", win));
        } else {
            //  UIManager.getRef("text_TotalWin_value_mobileFG").visible = true;
            //  UIManager.getRef("text_TotalWin_value_mobileFG") && (UIManager.setText("text_TotalWin_value_mobileFG", win));

        }
        this.storeWinAmount = this.props.totalWinAmount + this.storeWinAmount;
        this.setCharacter();

    }
    setCharacter() {
        let skeletonBtn, bodyBuilderBtn;
        skeletonBtn = UIManager.getRef("fg_skeletonCharacterBtn_" + this.ui_mode);
        bodyBuilderBtn = UIManager.getRef("fg_bodyBuilderCharacterBtn_" + this.ui_mode);
        if (this.props.bodyBuilderSelected) {
            skeletonBtn.visible = true;
            bodyBuilderBtn.visible = false;
            this.changeCharacter("fg_bodyBuilderCharecterIdle_" + this.ui_mode, "fg_skeletonCharacterIdle_" + this.ui_mode);
        }
        else {
            skeletonBtn.visible = false;
            bodyBuilderBtn.visible = true;
            this.changeCharacter("fg_skeletonCharacterIdle_" + this.ui_mode, "fg_bodyBuilderCharecterIdle_" + this.ui_mode);
        }
    }
    componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any) {


        UIManager.getRef("text_FreeGame_value1") && (UIManager.setText("text_FreeGame_value1", this.props.freegameSpinCount));

    }


    strokeButtonRotate() {
        if (isMobile && window.innerWidth < window.innerHeight) {
            UIManager.getRef("btn_spinStokeFG") && (UIManager.getRef("btn_spinStokeFG").rotation = 1.56);
        }
        else if (isMobile && window.innerWidth > window.innerHeight) {
            UIManager.getRef("btn_spinStokeFG") && (UIManager.getRef("btn_spinStokeFG").rotation = 0);
        }
    }


    setFGCountBannerText() {
        UIManager.getRef("text_FreeGame_value1") && (UIManager.setText("text_FreeGame_value1", this.props.freegameSpinCount));
        UIManager.getRef("text_FreeGame_value2") && (UIManager.setText("text_FreeGame_value2", this.props.freegameSpinCountWin));
    }

    chooseAssets() {
        let screen = window.screen;

        let isFullHD = false;
        if (((screen.width >= this.minFullHDWidth || screen.height >= this.minFullHDWidth) && window.devicePixelRatio >= this.minFullHDPxRatio) ||
            (screen.width >= this.HDReadyWidth || screen.height >= this.HDReadyWidth)) {
            isFullHD = true;
        }
        if (isFullHD) {
            this.canvasBgImagePage = "HD/assets/commongame/freegame_2048.jpg";
        } else {
            this.canvasBgImagePage = "LD/assets/commongame/freegame_2048.jpg";

        }
    }

    render() {
        (document.getElementsByClassName("canvasBgImage")[0] as any).src = this.canvasBgImagePage;

        return (
            <UIManager id={"freeGameGenericUIContainer"} type={"Container"} name={"freeGameGenericUIContainer"}
                ref={i => this.gameFreeGameBaseLayerContainer = i}>


                {
                    this.displayUI && this.displayUI.map((i: any) =>
                        <UIManager key={`UIManager-${Math.random()}`} langObj={this.props.langObj} type={i.type}
                            app={this.app} configGame={configGame}
                            id={i.id} {...i} ClickHandler={this.handleEvent} />)
                }
            </UIManager>)
    }

}

export default withPixiApp(connect(
    (state: Pick<IStore, 'randomWildsState' | 'giantWildState' | 'freegameState' | 'lockedReelState' | 'applicationState' | 'soundState' | 'gridsState' | 'flowManagerState' | 'behaviourState' | 'buttonPanelState' | 'behaviourState' | 'basegameState' | 'MultiplierState' | 'betPanelState'>): IStateToProps =>
    ({
        inFreeGame: state.freegameState.inFreeGame,
        layoutMode: state.applicationState.layoutMode,
        // winAmount: state.basegameState.winAmount,
        soundIsPlaying: state.soundState.soundIsPlaying,
        freegameSpinCountRemaining: state.freegameState.freegameSpinCountRemaining,
        freegameSpinCount: state.freegameState.freegameSpinCount,
        freegameSpinCountWin: state.freegameState.freegameSpinCountWin,
        currentCascadeCount: state.gridsState.currentCascadeCount,
        spinStopID: state.gridsState.spinStopID,
        displayReelGridSymbolCount: state.gridsState.displayReelGridSymbolCount,
        allSpinComplete: state.gridsState.allSpinComplete,
        featureJustReTriggered: state.freegameState.featureJustReTriggered,
        callFlowManager: state.flowManagerState.callFlowManager,
        featureJustFinished: state.freegameState.featureJustFinished,
        totalWinAmount: state.behaviourState.totalWinAmount,
        totalCreditWinAmount: state.behaviourState.totalCreditWinAmount,
        transitionBalance: state.behaviourState.transitionBalance,
        balance: state.basegameState.balance,
        betList: state.basegameState.betList,
        currentBetIndex: state.basegameState.currentBetIndex,
        multiplierActive: state.MultiplierState.multiplierActive,
        storeMultiplierCurrentValue: state.MultiplierState.storeMultiplierCurrentValue,
        selectedCoin: state.betPanelState.selectedCoin,
        coinList: state.betPanelState.coinList,
        spinStart: state.gridsState.spinStart,
        blastStart: state.gridsState.blastStart,
        winAmount: state.basegameState.winAmount,
        InTurboMode: state.gridsState.InTurboMode,
        lockedReelArr: state.lockedReelState.lockedReelArr,
        startGiantWild: state.giantWildState.startGiantWild,
        bodyBuilderSelected: state.giantWildState.bodyBuilderSelected,
        startRandomWild: state.randomWildsState.startRandomWild,
    }),
    (dispatch: Dispatch): IDispatchToProps => ({
        updateReelData: (result_reel: any): any => dispatch(gridsActions.updateReelData(result_reel)),
        setApplicationLayoutObject: (layoutobjectlist: any): any => dispatch(layoutsActions.setApplicationLayoutObject(layoutobjectlist)),
        activeMultiplier: (multiplierActive: boolean): any => dispatch(multiplierActions.activeMultiplier(multiplierActive)),
        playingSound: (soundIsPlaying: any): any => dispatch(soundActions.playingSound(soundIsPlaying)),
        stopAllBGMSound: (stopBgSound: any): any => dispatch(soundActions.stopAllBGMSound(stopBgSound)),
        nextAutoplay: (): any => dispatch(basegameAction.nextAutoplay()),
        nextFreegame: (): any => dispatch(freegameAction.nextFreegame()),
        stopFreegame: (): any => dispatch(freegameActions.stopFreegame()),
        setApplicationToBaseGameState: (basegamestate: boolean): any => dispatch(basegameActions.setApplicationToBaseGameState(basegamestate)),
        setMultiplierValue: (multiplierCurrentValue: any): any => dispatch(multiplierActions.setMultiplierValue(multiplierCurrentValue)),
        setTotalCreditWinAmount: (totalCreditWinAmount: any): any => dispatch(behaviourAction.setTotalCreditWinAmount(totalCreditWinAmount)),
        resetMultiwaysValue: (resetMultiWaysTextToInitial: any): any => dispatch(behaviourAction.resetMultiwaysValue(resetMultiWaysTextToInitial)),
        setAllButtonEnable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonEnable(exceptBtnList)),
        setGridList: (grid: any): any => dispatch(horizontalSymbolActions.setGridList(grid)),
        setWinHorizontalSymbolCoOrdinate: (winSymbolCoOrdinate: any): any => dispatch(horizontalSymbolActions.setWinSymbolCoOrdinate(winSymbolCoOrdinate)),
        setShowLockedReel: (): any => dispatch(lockedReelActions.setShowLockedReel()),
        setApplicationButtonpanelVisibility: (visible: boolean): any => dispatch(aplicationActions.setApplicationButtonpanelVisibility(visible)),
        soundLoadStartFunction: (soundLoadStart: boolean): any => dispatch(soundActions.soundLoadStartFunction(soundLoadStart)),
        stopAllSFXSound: (stopSfxSound: any): any => dispatch(soundActions.stopAllSFXSound(stopSfxSound)),
        setMultiplierForBuyFeature: (updateMultiplierForBuyFeature: any): any => dispatch(behaviorActions.setMultiplierForBuyFeature(updateMultiplierForBuyFeature)),
        changeCharacter: (bodyBuilderSelected: any): any => dispatch(giantWildActions.changeCharacter(bodyBuilderSelected)),
    }))(withFreeGameConfiguration(GameFreeGameSpecialLayer)));